import { Box } from '@mui/material';
import * as R from 'ramda';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import Drawer from '../../../Drawer/Drawer';
import { DrawerProps, FilterStep } from '../../filter.types';
import FilterOptionList from '../Filter/FilterOptionList';
import FilterSelectedOptionList from '../Filter/FilterSelectedOptionList';

const MobileDrawer = ({
  anchorEl,
  handleClosePopover,
  menu,
  options,
  handleSelectFilter,
  list,
}: DrawerProps) => {
  const { translate } = useTranslation();

  return (
    <Drawer
      isOpen={!!anchorEl}
      onClose={handleClosePopover}
      onOpen={() => {
        anchorEl;
      }}
      anchor="bottom"
      title={
        !R.isNil(menu.filterIndex) && options[menu.filterIndex]?.title
          ? options[menu.filterIndex].title
          : translate(LangEnum.GLOBAL_ADD_FILTERS)
      }
    >
      <Box
        sx={{
          display: menu.step === FilterStep.FIRST_STEP ? 'flex' : 'none',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <FilterOptionList options={options} onClick={handleSelectFilter} />
      </Box>
      {menu.step === FilterStep.SECOND_STEP &&
        !R.isNil(menu.filterIndex) &&
        options[menu.filterIndex] && (
          <FilterSelectedOptionList
            list={list}
            onClickApply={handleClosePopover}
            option={options[menu.filterIndex]}
            isDrawer
          />
        )}
    </Drawer>
  );
};

export default MobileDrawer;
